import { render, staticRenderFns } from "./details_modal.vue?vue&type=template&id=0864c1b8"
import script from "./details_modal.vue?vue&type=script&lang=js"
export * from "./details_modal.vue?vue&type=script&lang=js"
import style0 from "./details_modal.vue?vue&type=style&index=0&id=0864c1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports